import { createSlice } from "@reduxjs/toolkit";
import {
  InspectionStandardQuestionnaireDownloadStatusType,
  InspectionStandardQuestionnaireReportType,
} from "./InspectionStandardQuestionnaireTemplate.types";
import { InspectionStandardQuestionExcelDTO } from "../../../common/types/common.dto.types";

const initialState = {
  InspectionStandardQuestionnaire:
    {} as Array<InspectionStandardQuestionExcelDTO>,
} as InspectionStandardQuestionnaireReportType;

const inspectionStandardQuestionnaireSlice = createSlice({
  name: "InspectionStandardQuestionnaireReport",
  initialState: initialState,
  reducers: {
    setInspectionStandardQuestionnaireReportData: (
      state,
      action: { payload: Array<InspectionStandardQuestionExcelDTO> }
    ) => {
      return {
        ...state,
        InspectionStandardQuestionnaire: action.payload,
      };
    },
    setQuestionnaireExcelReportStatus: (
      state,
      action: { payload: InspectionStandardQuestionnaireDownloadStatusType }
    ) => {
      return { ...state, QuestionnaireExcelReportStatus: action.payload };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const inspectionStandardQuestionnaireReducerActions =
  inspectionStandardQuestionnaireSlice.actions;
export const inspectionStandardQuestionnaireReducer =
  inspectionStandardQuestionnaireSlice.reducer;
